import React, { useEffect, useState } from 'react';

import { breakpoints } from '@edx/paragon';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { getConfig } from '@edx/frontend-platform';

import { DefaultLargeLayout, DefaultMediumLayout, DefaultSmallLayout } from './components/default-layout';
import {
  ImageExtraSmallLayout, ImageLargeLayout, ImageMediumLayout, ImageSmallLayout,
} from './components/image-layout';
import { AuthLargeLayout, AuthMediumLayout, AuthSmallLayout } from './components/welcome-page-layout';
import { DEFAULT_LAYOUT, IMAGE_LAYOUT } from './data/constants';

const BaseContainer = ({ children, showWelcomeBanner, username }) => {
  const [baseContainerVersion, setBaseContainerVersion] = useState(DEFAULT_LAYOUT);

  useEffect(() => {
    const initRebrandExperiment = () => {
      if (window.experiments?.rebrandExperiment) {
        setBaseContainerVersion(window.experiments?.rebrandExperiment?.variation);
      } else {
        window.experiments = window.experiments || {};
        window.experiments.rebrandExperiment = {};
        window.experiments.rebrandExperiment.handleLoaded = () => {
          setBaseContainerVersion(window.experiments?.rebrandExperiment?.variation);
        };
      }
    };
    initRebrandExperiment();
  }, []);

  if (baseContainerVersion === IMAGE_LAYOUT) {
    return (
        <div className="layout">
          <h1 className="header-logo">
            <a href={`${getConfig().LMS_BASE_URL}`}>
                <h1 className="unu-logo-text">United Nations University</h1>
                <p className="unu-logo-tag-text">Institute for Water, Environment and Health</p>
            </a>
          </h1>
          <div className={classNames('content', { 'align-items-center mt-0': showWelcomeBanner })}>
            {children}
          </div>
      </div>
    );
  }

  return (
    <>
      <div className="layout">
        <h1 className="header-logo">
          <a href={`${getConfig().LMS_BASE_URL}`}>
              <h1 className="unu-logo-text">United Nations University</h1>
              <p className="unu-logo-tag-text">Institute for Water, Environment and Health</p>
          </a>
        </h1>
          <div className={classNames('content', { 'align-items-center mt-0': showWelcomeBanner })}>
            {children}
          </div>
      </div>
    </>
  );
};

BaseContainer.defaultProps = {
  showWelcomeBanner: false,
  username: null,
};

BaseContainer.propTypes = {
  children: PropTypes.node.isRequired,
  showWelcomeBanner: PropTypes.bool,
  username: PropTypes.string,
};

export default BaseContainer;
